#import "../../../editions/graphql/fragments/template-stub-fragment.graphql"
mutation TemplateCreate($input: TemplateCreateInput!) {
    templateCreate(input: $input) {
        template {
            ...TemplateStubFragment
        }
    }
}
